export default __webpack_public_path__ + "static/media/IGA_logo.14c5f56b.png";